<div class="flex justify-between mb-4">
  <div class="text-xl text-gray-700 font-bold">Reserva Compras</div>
</div>

<mat-tab-group animationDuration="400ms">
  <mat-tab label="Por TG">
    <div class="mt-4">
      <reserva-compras-tg />
    </div>
  </mat-tab>
  <mat-tab label="Por Ordem de Serviço">
    <div class="mt-4">
      <reserva-compras-os />
    </div>
  </mat-tab>
</mat-tab-group>
